/**
 * Display (of the mode of simple or detailed) Model
 * @author tbroussard
 *
 * This model defines properties used for toggling different UI display mode
 * options for transactions.
 *
 * Triggers a global Backbone event to notify listeners when the mode has
 * changed.
 */
import Backbone from 'backbone';

export default Backbone.Model.extend({
	defaults: {
		showActivityDetailedView: false
	},

	initialize(params = {}) {
		this.set('showActivityDetailedView', params.showDetailedView === true);
	},

	isDetailedMode() {
		return this.get('showActivityDetailedView') === true;
	},

	toggleMode(selectedDisplayMode) {
		const currentMode = this.getMode();

		// don't change the display mode if you are selecting the same one that is currently being displayed
		if (currentMode !== selectedDisplayMode) {
			this.set('showActivityDetailedView', !this.get('showActivityDetailedView'));

			// TransactionView and TransactionCollectionView are listeners
			Backbone.trigger('displayMode:change', this.getMode());

			const displayMode = this.getMode();
			Backbone.trigger('trackLink', null, displayMode, 'main:walletweb:activity:' + displayMode + ':', null, 'link');
		}
	},

	getMode() {
		if (this.isDetailedMode()) {
			return 'detailed';
		}

		return 'simple';
	}
});



// WEBPACK FOOTER //
// ./model/activity/displayModel.es6